'use client';

import { c as _c } from "react/compiler-runtime";
import { RadioGroup as RadioGroupPrimitive } from 'radix-ui';
import { tv } from 'tailwind-variants';
import type { VariantProps } from 'tailwind-variants';
const radioGroup = tv({
  base: `
    flex
    gap-2
  `,
  variants: {
    orientation: {
      horizontal: 'flex-row',
      vertical: 'flex-col'
    }
  },
  defaultVariants: {
    orientation: 'vertical'
  }
});
function RadioGroup(t0) {
  const $ = _c(10);
  let className;
  let orientation;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      orientation,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = orientation;
    $[3] = props;
  } else {
    className = $[1];
    orientation = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className || $[5] !== orientation) {
    t1 = radioGroup({
      className,
      orientation
    });
    $[4] = className;
    $[5] = orientation;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== props || $[8] !== t1) {
    t2 = <RadioGroupPrimitive.Root className={t1} data-slot="radio-group" {...props} />;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
const radioGroupItem = tv({
  slots: {
    base: `
      border-input
      focus-visible:ring-content-primary
      aria-invalid:ring-destructive/20
      dark:aria-invalid:ring-destructive/40
      aria-invalid:border-destructive
      dark:bg-input/30
      disabled:bg-background-disabled
      enabled:cursor-pointer
      disabled:cursor-not-allowed
      disabled:[&_[data-slot=radio-group-indicator]]:bg-background-disabled
      aspect-square
      size-4
      shrink-0
      rounded-full
      border
      transition-colors
      outline-none
      focus-visible:ring-1
      focus-visible:ring-offset-1
    `,
    indicator: `
      text-background-primary
      relative
      flex
      h-full
      w-full
      items-center
      justify-center
      rounded-full
    bg-black
    `
  }
});
function RadioGroupItem(t0) {
  const $ = _c(17);
  let T0;
  let T1;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== t0) {
    const {
      className,
      ...props
    } = t0;
    const {
      base,
      indicator
    } = radioGroupItem(props);
    T1 = RadioGroupPrimitive.Item;
    t2 = base({
      className,
      ...props
    });
    t3 = "radio-group-item";
    t4 = props;
    T0 = RadioGroupPrimitive.Indicator;
    t1 = indicator();
    $[0] = t0;
    $[1] = T0;
    $[2] = T1;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    T0 = $[1];
    T1 = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 !size-1.5 rounded-full bg-white" />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== T0 || $[9] !== t1) {
    t6 = <T0 className={t1} data-slot="radio-group-indicator">{t5}</T0>;
    $[8] = T0;
    $[9] = t1;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== T1 || $[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t6) {
    t7 = <T1 className={t2} data-slot={t3} {...t4}>{t6}</T1>;
    $[11] = T1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}
export { radioGroup, radioGroupItem, RadioGroup, RadioGroupItem };